export default __webpack_public_path__ + "static/media/0066.203b6e3a.png";